import { useEffect, useRef, useState } from "react";
import { pub, mediaUrl, getCookie, setCookie } from "@/lib/api";
import { Shell, useSiteConfig } from "./Shell";

function useSourceCode() {
  const [code, setCode] = useState(getCookie("sos_code"));
  useEffect(() => {
    const src = new URLSearchParams(window.location.search).get("src");
    if (code && (!src || getCookie("sos_src") === src)) return;
    pub.post("/visit", { src }).then((r) => {
      setCookie("sos_code", r.data.code);
      if (src) setCookie("sos_src", src);
      setCode(r.data.code);
    }).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return code;
}

export default function TeaserPage() {
  const cfg = useSiteConfig();
  const code = useSourceCode();
  const video = useRef(null);
  const [playing, setPlaying] = useState(false);
  const email = cfg?.m_email || "m@333sos.com";
  const portrait = typeof window !== "undefined" && window.innerHeight > window.innerWidth;
  const useSocial = portrait && cfg?.has_teaser_social;
  const hasVideo = cfg?.has_teaser || cfg?.has_teaser_social;
  const slot = useSocial || !cfg?.has_teaser ? "teaser_social" : "teaser";
  const mailto = `mailto:${email}${code ? `?subject=${encodeURIComponent(`signal ${code}`)}` : ""}`;

  const toggle = () => {
    const v = video.current;
    if (!v) return;
    if (v.paused) { v.play().then(() => setPlaying(true)).catch(() => {}); } else { v.pause(); setPlaying(false); }
  };

  return (
    <Shell testid="teaser-page" className="bg-black">
      <div className="flex-1 flex flex-col items-center justify-center px-0 sm:px-8">
        {hasVideo ? (
          <button type="button" onClick={toggle} data-testid="teaser-play-toggle" className={`relative bg-black outline-none ${slot === "teaser_social" ? "h-[78dvh] aspect-[9/16] max-w-full" : "w-full max-w-5xl aspect-video"}`}>
            <video ref={video} data-testid="teaser-video" data-cut={slot} src={mediaUrl(slot)} playsInline preload="metadata" className="w-full h-full object-contain" onEnded={() => setPlaying(false)} />
            {!playing && <span className="absolute inset-0 flex items-center justify-center text-[11px] tracking-[0.4em] text-[color:var(--w1-muted)] w1-fade-in">TAP</span>}
          </button>
        ) : (
          <div data-testid="teaser-placeholder" className="w-full max-w-5xl aspect-video border border-[color:var(--w1-border)] flex items-center justify-center text-[11px] tracking-[0.3em] text-[color:var(--w1-muted)]">
            [ TEASER PLACEHOLDER ]
          </div>
        )}
        <a href={mailto} data-testid="mailto-button" className="mt-10 py-3 text-xs tracking-[0.35em] text-[color:var(--w1-blue-dim)] hover:text-[color:var(--w1-blue)] transition-colors w1-fade-in" style={{ animationDelay: "0.6s" }}>
          {email.toUpperCase()}
        </a>
      </div>
    </Shell>
  );
}
